/* unplugin-vue-components disabled */import { render } from "./reasoning.vue?vue&type=template&id=d4c0be24&scoped=true"
import script from "./reasoning.vue?vue&type=script&lang=js"
export * from "./reasoning.vue?vue&type=script&lang=js"

import "./reasoning.vue?vue&type=style&index=0&id=d4c0be24&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c0be24"],['__file',"src/components/ai-chat/ai-assistant/research/reasoning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4c0be24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4c0be24', __exports__)) {
    api.reload('d4c0be24', __exports__)
  }
  
  module.hot.accept("./reasoning.vue?vue&type=template&id=d4c0be24&scoped=true", () => {
    api.rerender('d4c0be24', render)
  })

}


export default __exports__